/** Set B /ldproductnow motivation option keys. */
export const SET_B_LD_MOTIVATION_KEYS = [
  'productQuality',
  'price',
  'peerRecommendation',
  'strongTaste',
  'smoothDelivery',
  'mentholFlavorExperience',
  'other',
] as const;

export type SetBLdMotivationKey = (typeof SET_B_LD_MOTIVATION_KEYS)[number];

export const SET_B_LD_MOTIVATION_LABELS: Record<SetBLdMotivationKey, string> = {
  productQuality: 'Product quality',
  price: 'Price',
  peerRecommendation: 'Peer recommendation',
  strongTaste: 'Strong taste',
  smoothDelivery: 'Smooth delivery',
  mentholFlavorExperience: 'Menthol & flavor experience',
  other: 'Other reasons',
};

export function isSetBLdMotivationKey(value: unknown): value is SetBLdMotivationKey {
  return typeof value === 'string' && (SET_B_LD_MOTIVATION_KEYS as readonly string[]).includes(value);
}
